import {Component, Input} from '@angular/core';

import {IUserGuide} from '../../shared/user-guide.model';
import {UserGuideStore} from '../../shared/user-guide.store';

@Component({
  selector: 'app-user-guide-accordion',
  templateUrl: './user-guide-accordion.component.html',
  styleUrls: ['./user-guide-accordion.component.scss'],
})
export class UserGuideAccordionComponent {
  @Input() userGuide: IUserGuide[];

  constructor(private userGuideStore: UserGuideStore) {}

  onToggleSection(item: IUserGuide): void {
    this.userGuideStore.toggleActiveSection(item.index);
  }
}
